if (!customElements.get('featured-collection')) {
  class FeaturedCollection extends HTMLElement {
    connectedCallback() {
      this.init();
      this.handleResize();
    }

    init() {
      this.carousel = this.querySelector('.main-carousel');
      this.progressBar = this.querySelector('.progress-bar');
      this.prevBtn = this.querySelector('.flickity-previous');
      this.nextBtn = this.querySelector('.flickity-next');
      this.flkty = null;

      this.initFlickity();
      this.handleButtons();

      window.addEventListener('load', () => {
        if (this.flkty) {
          this.flkty.resize();
        }
      }, { once: true }); 
    }

    initFlickity() {
      if (!this.carousel) return;

      // Destroy existing instance
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }

      this.flkty = new Flickity(this.carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        imagesLoaded: true,
      });

      if (!this.progressBar) return;

      const totalSlides = this.flkty.slides.length;
      const baseProgress = 1 / totalSlides;

      // Initial state (first slide already filled)
      this.progressBar.style.width = `${baseProgress * 100}%`;

      this.flkty.on('scroll', (progress) => {
        progress = Math.max(0, Math.min(1, progress));

        const adjustedProgress =
          baseProgress + progress * (1 - baseProgress);

        this.progressBar.style.width = `${adjustedProgress * 100}%`;
      });
    }

    handleButtons() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.flkty && this.flkty.previous();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.flkty && this.flkty.next();
        });
      }
    }

    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this, args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    handleResize() {
      let lastWidth = window.innerWidth;

      this.debouncedResize = this.debounce(() => {
        const newWidth = window.innerWidth;
        if (newWidth === lastWidth) return;
        lastWidth = newWidth;

        if (this.flkty) {
          this.flkty.resize();
        }
      }, 200);

      window.addEventListener('resize', this.debouncedResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.debouncedResize);
      if (this.flkty) this.flkty.destroy();
    }
  }

  customElements.define('featured-collection', FeaturedCollection);
}